import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular';
import { GlobalCSSVariablesService } from './services/global-css-variables.service';
import { PwaUpdateService } from './services/pwa-update.service';
import { PwaInstallService } from './services/pwa-install.service';
import { BrowserHandlerService } from './services/browser-handler.service';
import { KeyboardDetectionService } from './services/keyboard-detection.service';
import { DataStateService } from './services/data-state.service';
import { AuthService } from './services/auth.service';
import { OfflineIndicatorComponent } from './components/offline-indicator/offline-indicator.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, OfflineIndicatorComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private globalCSSVariablesService = inject(GlobalCSSVariablesService);
  private pwaUpdateService = inject(PwaUpdateService);
  private pwaInstallService = inject(PwaInstallService);
  private browserHandlerService = inject(BrowserHandlerService);
  private keyboardDetectionService = inject(KeyboardDetectionService);
  private dataStateService = inject(DataStateService);
  private authService = inject(AuthService);


  ngOnInit(): void {
    // Request persistent storage so iOS/browsers are less likely to evict caches (important for offline PWA)
    if (typeof navigator !== 'undefined' && navigator.storage?.persist) {
      navigator.storage.persist().then(() => {}).catch(() => {});
    }

    // Initialize PWA Update Service first
    this.pwaUpdateService.init();
    
    // Initialize PWA Install Service with reference to Update Service
    // This allows the install service to trigger updates after installation
    this.pwaInstallService.init(this.pwaUpdateService);
    
    this.browserHandlerService.init();
    this.keyboardDetectionService.init();

    // Start background sync if user is already authenticated
    if (this.authService.isLoggedIn()) {
      this.dataStateService.startBackgroundSync();
    }
  }

  ngOnDestroy(): void {
    // Stop background sync on app destroy
    this.dataStateService.stopBackgroundSync();
    
    // Services handle their own cleanup via OnDestroy
  }

}
